<template>
  <div id="blog" class="blog-page">
    <section class="blog-profile min-h-screen">
      <div class="container">
        <div class="content">
          <div class="title">
            <h1 class="h1">Forrás minden, az irodához köthető témáról</h1>
          </div>

          <div class="text">
            <p>
              Nem csak a budapesti irodapiacról, de a bérleti tárgyalások red
              flag-jeiől egészen az interior designig!
            </p>
          </div>

          <div class="loader" v-if="true">
            <beat-loader :loading="isLoading" :color="'#2424FC'"></beat-loader>
          </div>

          <div class="selected-tag" v-if="$route.params.tag">
            <div class="selected-tag-text">
              {{ $route.params.tag }}
            </div>

            <router-link
              class="selected-tag-link"
              :to="{
                path: `/blog`,
                hash: 'enter'
              }"
            >
              <Close />
            </router-link>
          </div>

          <div class="posts" id="posts">
            <BlogPostCard v-for="post in posts" :key="post.id" :post="post" />
          </div>

          <div class="pagination">
            <router-link
              v-if="page !== 1"
              :to="{
                path: `/blog${
                  $route.params.tag ? `/tag/${$route.params.tag}` : ''
                }?page=${page - 1}`,
                hash: 'enter'
              }"
              class="p-button"
            >
              <ArrowLeft />
            </router-link>
            <router-link
              v-if="hasMore"
              :to="{
                path: `/blog${
                  $route.params.tag ? `/tag/${$route.params.tag}` : ''
                }?page=${page + 1}`,
                hash: 'enter'
              }"
              class="p-button"
            >
              <ArrowRight />
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import BeatLoader from "vue-spinner/src/PulseLoader.vue";
import ArrowLeft from "@/components/icons/ArrowLeft";
import ArrowRight from "@/components/icons/ArrowRight";
import Close from "@/components/icons/Close";
import BlogPostCard from "@/components/BlogPostCard";

export default {
  name: "Blog",
  metaInfo: {
    title: "Blog | Offie",
    meta: [
      {
        name: "description",
        content:
          "Nem csak a budapesti irodapiacról, de a bérleti tárgyalások red flag-jeiől egészen az interior designig!"
      },
      {
        name: "og:title",
        content: "Forrás minden, az irodához köthető témáról"
      },
      {
        name: "og:description",
        content:
          "Nem csak a budapesti irodapiacról, de a bérleti tárgyalások red flag-jeiől egészen az interior designig!"
      },
      {
        name: "og:image",
        content: `https://offie.hu/logo.png`
      }
    ]
  },
  components: {
    BeatLoader,
    ArrowLeft,
    ArrowRight,
    Close,
    BlogPostCard
  },
  data() {
    return {
      limit: 9,
      posts: [],
      isLoading: true,
      hasMore: true
    };
  },
  methods: {
    async getPosts(page, tagSlug) {
      const query = {
        ...(tagSlug ? { filters: { tags: { slug: { $eq: tagSlug } } } } : {}),
        populate: ["coverImage", "tags"],
        sort: ["publishedAt:desc"],
        pagination: {
          limit: this.limit,
          start: page * this.limit
        }
      };

      try {
        return axios.get(`blog-posts?${qs.stringify(query)}`);
      } catch (e) {
        // console.log(e);
      }
    }
  },
  computed: {
    page() {
      return parseInt(this.$route.query.page ?? 1);
    }
  },
  watch: {
    "$route.query": {
      async handler() {
        this.isLoading = true;

        const posts = await this.getPosts(
          this.page - 1,
          this.$route.params.tag
        );

        this.posts = posts.data.data;
        this.hasMore = true;
        if (posts.data.meta.pagination.total <= this.page * this.limit) {
          this.hasMore = false;
        }

        this.isLoading = false;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
.blog-page {
  background: $white;
  display: flex;
  flex-direction: column;

  .fullscreen {
    position: fixed;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $black;
    opacity: 0;
    transition: all 0.3s ease-in-out;
    &.opened {
      z-index: 1000;
      opacity: 1;
    }
    picture {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
.blog-profile {
  padding: 0 0 54px !important;
  background: $background;
  display: block;
  width: 100%;
  .container {
    .content {
      display: flex;
      flex-direction: column;
      .loader {
        text-align: center;
        margin-bottom: 20px;
        height: 28px;
      }
      .head {
        padding: 0 16px;
        margin-bottom: 24px;
      }
      .title {
        padding: 0 16px;
        margin-bottom: 12px;
        .h1 {
          font-size: 38px;
          line-height: 40px;
          font-weight: 500;
        }
      }
      .text {
        padding: 0 16px;
        .h3 {
          margin-bottom: 8px;
        }
      }
      .pagination {
        display: flex;
        justify-content: end;
        margin-top: 20px;
        padding: 0 16px;
        .p-button {
          margin-left: 10px;
          font-size: 14px;
          padding: 5px 5px 0px;
          background-color: #2424fc;
          color: white;
          border-radius: 8px;
          &:hover {
            background-color: #3152f6;
          }
        }
      }
      .selected-tag {
        margin-bottom: 15px;
        font-size: 16px;
        margin-left: 16px;
        padding: 5px;
        background-color: #2424fc;
        color: white;
        border-radius: 8px;
        display: inline-block;
        display: flex;
        align-items: center;
        margin-right: auto;
        .selected-tag-text {
          margin-right: 5px;
        }
        .selected-tag-link {
          display: flex;
        }
      }
      .posts {
        padding: 16px;
        display: grid;
        grid-template-columns: 1fr;
        column-gap: 30px;
        row-gap: 30px;
      }
      .control {
        margin: 0 16px 24px;
        .button {
          width: 100%;
        }
      }
    }
  }
  @media screen and (min-width: 550px) {
    .container {
      .content {
        .posts {
          padding: 16px;
          grid-template-columns: 1fr 1fr;
        }
      }
    }
  }
  @media screen and (min-width: $breakpoint) {
    margin: 0;
    padding: 40px 0 168px 0 !important;
    .container {
      position: relative;

      .content {
        position: relative;
        z-index: 10;
        justify-content: space-between;
        // margin-top: -240px;
        // padding-top: 240px;
        display: flex;
        //height: 800px;
        justify-content: flex-start;
        flex-wrap: wrap;
        flex-direction: column;
        .head {
          padding: 0 100px 0 0;
          .button {
            display: inline-flex;
          }
        }
        .title {
          //width: 60%;
          box-sizing: border-box;
          padding: 0 100px 0 0;
          //margin-bottom: 16px;
          .h1 {
            font-size: 54px;
            line-height: 60px;
            font-weight: 500;
          }
        }
        .selected-tag {
          margin-left: 0px;
        }
        .posts {
          grid-template-columns: 1fr 1fr 1fr;
          padding: 0px;
        }
        .pagination {
          padding: 0px;
        }
        .text {
          //width: 60%;
          box-sizing: border-box;
          padding: 0 100px 0 0;
          // margin-bottom: 24px;
          p {
            margin: 0 0 16px 0;
          }
        }
        .control {
          //width: 60%;
          box-sizing: border-box;
          padding: 0 100px 0 0;
          margin: 0;
          .button {
            width: auto;
          }
        }
      }
    }
  }
}
</style>
